var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2871",
    "data-name": "Group 2871",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.656,
    height: 19.656,
    viewBox: "0 0 19.656 19.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M0,0H19.656V19.656H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M2,10.256A8.219,8.219,0,0,1,2.259,8.2a2.457,2.457,0,0,0,2.19-3.791A8.182,8.182,0,0,1,8,2.362a2.457,2.457,0,0,0,4.38,0,8.182,8.182,0,0,1,3.55,2.052,2.457,2.457,0,0,0,2.191,3.792,8.252,8.252,0,0,1,0,4.1A2.457,2.457,0,0,0,15.93,16.1a8.182,8.182,0,0,1-3.55,2.052,2.457,2.457,0,0,0-4.38,0A8.182,8.182,0,0,1,4.449,16.1a2.457,2.457,0,0,0-2.191-3.792A8.236,8.236,0,0,1,2,10.256Zm3.935,2.457A4.092,4.092,0,0,1,6.4,15.6a6.558,6.558,0,0,0,1.062.614,4.1,4.1,0,0,1,5.463,0,6.558,6.558,0,0,0,1.062-.614,4.095,4.095,0,0,1,2.731-4.729,6.656,6.656,0,0,0,0-1.229,4.094,4.094,0,0,1-2.731-4.729A6.543,6.543,0,0,0,12.921,4.3a4.1,4.1,0,0,1-5.462,0A6.544,6.544,0,0,0,6.4,4.912,4.095,4.095,0,0,1,3.666,9.641a6.655,6.655,0,0,0,0,1.229,4.089,4.089,0,0,1,2.269,1.843Zm4.256,0a2.457,2.457,0,1,1,2.457-2.457A2.457,2.457,0,0,1,10.19,12.713Zm0-1.638a.819.819,0,1,0-.819-.819A.819.819,0,0,0,10.19,11.075Z",
    transform: "translate(-0.362 -0.427)",
    fill: "#f5ca3d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingYellow);
export default __webpack_public_path__ + "static/media/setting-yellow.f04a01aa856d6e08f0552adb58571251.svg";
export { ForwardRef as ReactComponent };